const BASE_URL = process.env.REACT_APP_BASE_URL;

export const authEndpoints = {
    RESETPASSTOKEN_API: BASE_URL + '/auth/generateResetPasswordToken',
    RESETPASSWORD_API: BASE_URL + '/auth/resetPassword',
    SENDOTP_API: BASE_URL + '/auth/verification',
    SIGNUP_API: BASE_URL + '/auth/signup',
    LOGIN_API: BASE_URL + '/auth/login',
    UPDATE_PASSWORD_API: BASE_URL + '/auth/change-password'
}

export const profileEndpoints = {
    USERDETAIL_API: BASE_URL + '/profile/getUserDetail',
    UPDATE_PROFILE_PICTURE_API: BASE_URL + '/profile/displayPicture',
    UPDATE_PROFILE_API: BASE_URL + '/profile/updateProfile',
    DELETE_ACCOUNT_API: BASE_URL + '/profile/deleteAccount',
    UPDATE_NAME_API: BASE_URL + '/profile/update-name',
    GET_USER_ENROLLED_COURSES_API: BASE_URL + '/profile/getAllEnrolledCourses',
    GET_INSTRUCTORE_DETAIL_API: BASE_URL + '/profile/getInstructorDetail',
}

export const contactusEndpoint = {
    CONTACTUS_API: BASE_URL + '/contactus',
}

export const courseEndpoints = {
    CREATE_COURSE_API: BASE_URL + '/course/createCourse',
    CREATE_SECTION_API: BASE_URL + '/course/addSection',
    UPDATE_SECTION_API: BASE_URL + '/course/updateSection',
    DELETE_SECTION_API: BASE_URL + '/course/deleteSection',
    CREATE_SUB_SECTION_API: BASE_URL + '/course/addSubSection',
    UPDATE_SUB_SECTION_API: BASE_URL + '/course/updateSubSection',
    DELETE_SUB_SECTION_API: BASE_URL + '/course/deleteSubSection',
    GET_SPECIFIC_COURSE_API: BASE_URL + '/course/getCourse',
    GET_COMPLETE_COURSE_API: BASE_URL + '/course/getCompleteCourse',
    GET_ALL_COURSES_API: BASE_URL + '/course/getAllCourses',
    GET_CATEGORIES_API: BASE_URL + '/course/getAllCategories',
    GET_COURSE_FEES_COURSES_API: BASE_URL + '/course/getCourseFeedCourses',
    CREATE_CATEGORY_API: BASE_URL + '/course/createCategory',
    GET_CATEGORY_PAGE_DETAILS_API: BASE_URL + '/course/getCategoryPageDetails',
    CREATE_RATING_REVIEW_API: BASE_URL + '/course/createRating',
    UPDATE_RATING_REVIEW_API: BASE_URL + '/course/updateRatingAndReview',
    GET_AVERAGE_RATING_REVIEW_API: BASE_URL + '/course/getAverageRating',
    GET_ALL_RATING_REVIEW_API: BASE_URL + '/course/getAllRatingReview',
    GET_ALL_INSTRUCTORE_COURSES_API: BASE_URL + '/course/getInstructorCourses',
    DELETE_COURSE_API: BASE_URL + '/course/deleteCourse',
    UPDATE_COURSE_PROGRESS_API: BASE_URL + '/course/updateCourseProgress',
}

export const studentBuyCourseEndpoints = {
    COURSE_PAYMENT_API: BASE_URL + "/payment/capturePayment",
    COURSE_VERIFY_API: BASE_URL + "/payment/verifyPayment",
    SEND_PAYMENT_SUCCESS_EMAIL_API: BASE_URL + "/payment/sendPaymentSuccessEmail",
}